import React, { Component } from 'react'
import MenuBar from './components/menubar'
// import {Layout,Header,Textfield,Drawer,Navigation,Content,HeaderRow} from 'react-mdl';
import './App.css'

class App extends React.Component {
  render () {
    return (
      <div>
        <MenuBar />
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js